/**
 * Liquid section divider — an animated flowing wave that separates sections.
 * Uses SVG with animated turbulence to create a fluid, organic boundary.
 */
export default function LiquidDivider() {
  return (
    <div className="relative h-24 sm:h-32 overflow-hidden pointer-events-none select-none">
      {/* Flowing gradient line */}
      <div className="absolute inset-x-0 top-1/2 -translate-y-1/2 h-px">
        <div
          className="w-full h-full"
          style={{
            background:
              'linear-gradient(90deg, transparent 0%, rgba(30,64,175,0.15) 20%, rgba(124,58,237,0.25) 50%, rgba(6,182,212,0.15) 80%, transparent 100%)',
          }}
        />
      </div>

      {/* Animated liquid blobs */}
      <svg
        className="absolute inset-0 w-full h-full opacity-30"
        viewBox="0 0 1200 100"
        preserveAspectRatio="none"
      >
        <defs>
          <linearGradient id="liquid-grad" x1="0%" y1="0%" x2="100%" y2="0%">
            <stop offset="0%" stopColor="#1E40AF" stopOpacity="0" />
            <stop offset="30%" stopColor="#1E40AF" stopOpacity="0.4" />
            <stop offset="50%" stopColor="#7C3AED" stopOpacity="0.6" />
            <stop offset="70%" stopColor="#06B6D4" stopOpacity="0.4" />
            <stop offset="100%" stopColor="#06B6D4" stopOpacity="0" />
          </linearGradient>
        </defs>

        {/* Wave paths — these create the organic flowing divider */}
        <path
          d="M0,50 C200,30 400,70 600,50 C800,30 1000,70 1200,50"
          fill="none"
          stroke="url(#liquid-grad)"
          strokeWidth="1"
          className="animate-liquid-wave"
        />
        <path
          d="M0,50 C200,65 400,35 600,50 C800,65 1000,35 1200,50"
          fill="none"
          stroke="url(#liquid-grad)"
          strokeWidth="0.5"
          opacity="0.5"
          className="animate-liquid-wave-reverse"
        />
      </svg>

      {/* Center glow dot */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2">
        <div
          className="w-1.5 h-1.5 rounded-full bg-accent-purple/60"
          style={{
            boxShadow: '0 0 12px rgba(124,58,237,0.4), 0 0 30px rgba(124,58,237,0.15)',
          }}
        />
      </div>
    </div>
  );
}
